function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M163 84.8h28.5v113.5H163V84.8zM28.3 255.1h226.8v28.3H28.3v-28.3zm205.6-7.2H49.7V111.1L7.2 28 186.8.1l54.7-.1c13.1 0 24.4 5.4 32 15.3 6.5 8.5 9.9 19.6 9.9 32.2v87.1H255V47.5c0-6.2-1.4-11.4-4-14.8-2.2-2.9-5.2-4.2-9.4-4.2H234l-.1 219.4zM78.2 219.4h127.2V28.6H189L52.8 49.9l25.4 53.5v116z"
})));